import { PropsWithChildren } from "react"

export const CenteringContainer = (props: PropsWithChildren) => (
  <div
    className="z-20 flex h-full w-full items-center justify-center"
    {...props}
  />
)
